export default "__VITE_ASSET__ClL9eqkU__"